import {Component, ViewChild} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {BenutzerModels} from '../../../models/benutzer-models';
import {UserAuthenticationService} from '../../../services/user-authentication.service';
import {AdresseModels} from '../../../models/adresse-models';
import {AdressEintragComponent} from '../adress-eintrag/adress-eintrag.component';
import {KontaktEintragComponent} from '../kontakt-eintrag/kontakt-eintrag.component';
import {MatDialog} from '@angular/material/dialog';
import {AdresseDataService} from '../../../services/adresse-data.service';
import {MessageBoxService} from '../../../services/message-box.service';
import {AddressNotizComponent} from '../address-notiz/address-notiz.component';
import {v4 as uuidv4} from 'uuid';
import {AddressSearchComponent} from '../address-search/address-search.component';
import {Router} from '@angular/router';
import {AddressDetailComponent} from '../address-detail/address-detail.component';
import AnsprechPartnerElement = AdresseModels.AnsprechPartnerElement;

@Component({
    selector: 'app-address-overview',
    templateUrl: './address-overview.component.html',
    styleUrl: './address-overview.component.scss'
})
export class AddressOverviewComponent {
    currentAddressID$: BehaviorSubject<string> = new BehaviorSubject('');
    @ViewChild('addressSearchComponent', {static: true}) addressSearchComponent!: AddressSearchComponent;
    @ViewChild('addressDetailComponent', {static: true}) addressDetailComponent!: AddressDetailComponent;
    protected readonly BenutzerModels = BenutzerModels;

    constructor(protected userAuthService: UserAuthenticationService, private dialog: MatDialog, private addressService: AdresseDataService, private messageBoxService: MessageBoxService, private router: Router) {
    }

    protected addressSelected(addressID: string): void {
        this.currentAddressID$.next(addressID);
    }

    protected async showNote(): Promise<void> {
        const adresseElement = await this.addressService.getAddressByID(this.currentAddressID$.getValue());
        this.dialog.open(AddressNotizComponent, {
            disableClose: true, width: '800px', data: adresseElement, panelClass: 'swissdefault-dialog-container',
        }).afterClosed().subscribe({
            next: (result: string) => {
                if (result !== undefined) {
                    // TODO 2026-01-27 https://swissjira.atlassian.net/browse/EN-4394 fix in backend, we get a country name as string while it requires a country object
                    this.addressService.getCountries().subscribe(countries => {
                        if (!adresseElement.country['isoShort']) {
                            const country = countries.find(c => c.isoNameNational === (adresseElement.country as any));
                            if (country) {
                                adresseElement.country = country;
                            }
                        }
                        adresseElement.note = result;
                        this.addressService.updateAdresse(adresseElement).subscribe();
                    });
                }
            },
        });
    }

    protected async onNewAddress(): Promise<void> {
        const adresseElement = AdresseModels.EmptyDetailAdresseElement(this.addressService.getDefaultCountry());
        adresseElement.adressID = uuidv4();

        this.dialog.open(AdressEintragComponent, {
            disableClose: true, width: '800px', data: adresseElement,
        }).afterClosed().subscribe({
            next: (result: any) => {
                this.currentAddressID$.next(adresseElement.adressID);
            },
        });
    }

    protected async onNewPartner(): Promise<void> {
        const partner = {
            adressID: '', adressNo: 0, hauptAnsprechpartner: 0, lastName: '', firstName: '', ansprechInfo: '', anrede: '', briefanrede: '', zuhanden: '', telefon: '', mobile: '', email: '', homepage: '', pers: 0,
        };

        this.dialog.open(KontaktEintragComponent, {
            disableClose: true, width: '800px', data: partner,
        }).afterClosed().subscribe({
            next: (result: AnsprechPartnerElement) => {
                result.adressID = uuidv4();
                this.addressService
                    .newAdressPartner(result, this.currentAddressID$.getValue())
                    .subscribe({
                        next: (res) => {
                            this.messageBoxService.showSuccess('Der Ansprechpartner wurde erfolgreich gespeichert. ', 'Erfolgreich');
                            this.addressDetailComponent.loadPartners(this.currentAddressID$.getValue());
                        }, error: (err) => console.error(err),
                    });
            }
        });
    }

    protected async delAddress(): Promise<void> {
        const addressID = this.currentAddressID$.getValue();
        if (addressID) {
            const response = await this.messageBoxService.askYesNoQuestion('MAIN_APP_DIALOG.DEL_ADDRESS.msg', 'MAIN_APP_DIALOG.DEL_ADDRESS.title', ['TODO LASTNAME']);
            if (response) {
                try {
                    (await this.addressService.deleteAddressByID(addressID)).subscribe(() => {
                        this.currentAddressID$.next('');
                        this.addressSearchComponent.reSearch();
                    });
                } catch (exception) {
                    await this.messageBoxService.showErrorOK('MAIN_APP_DIALOG.DEL_ADDRESS.CONNECTED_ENTITIES.text', 'MAIN_APP_DIALOG.DEL_ADDRESS.CONNECTED_ENTITIES.title');
                }
            }
        }
    }

    protected async objectSelected(objectID: string): Promise<void> {
        await this.router.navigate(['/objekte', objectID]);
    }
}
